import { useState, useEffect, useCallback } from "react";

export const useAuth = () => {
  const [authenticated, setAuthenticated] = useState(() => {
    const token = localStorage.getItem("authToken");
    const username = localStorage.getItem("username");
    const user = localStorage.getItem("user");
    return !!(token && username && user);
  });

  const checkAuthentication = useCallback(() => {
    const token = localStorage.getItem("authToken");
    const username = localStorage.getItem("username");
    const user = localStorage.getItem("user");
    return !!(token && username && user);
  }, []);

  const login = useCallback((token: string, username: string) => {
    localStorage.setItem("authToken", token);
    localStorage.setItem("username", username);
    setAuthenticated(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("username");
    localStorage.removeItem("user");
    localStorage.removeItem("queueAPI");
    setAuthenticated(false);

    // Dispatch custom event for theme context to update
    window.dispatchEvent(new CustomEvent("userChanged"));
  }, []);

  // Update authentication state when localStorage changes
  useEffect(() => {
    const handleStorageChange = () => {
      setAuthenticated(checkAuthentication());
    };

    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("userChanged", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("userChanged", handleStorageChange);
    };
  }, [checkAuthentication]);

  return {
    authenticated,
    checkAuthentication,
    login,
    logout,
  };
};
